module.exports = __webpack_public_path__ + "pw.svg?069ec370e716891db264087afdcf6182";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/1x1/pw.svg
// module id = 1324
// module chunks = 0